<template>
    <div>
      <svg style="display: none;">
        <defs>
          <symbol id="bmxz" viewBox="0 0 30 30" title="报名须知">
            <path d="M4.4 6.1l2.2 2.2 1.8-1.8-2.2-2.2-1.8 1.8zM13.8 5h2.5V1.2h-2.5V5zM1.2 16.2H5v-2.5H1.2v2.5zm23.8 0h3.8v-2.5H25v2.5zm-3.5-9.6l1.8 1.8 2.2-2.2-1.8-1.8-2.2 2.2zM11.2 25h7.5v-2.5h-7.5V25zM15 7.5c-4.1 0-7.5 3.4-7.5 7.5s3.4 7.5 7.5 7.5 7.5-3.4 7.5-7.5-3.4-7.5-7.5-7.5zm0 2.5c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5zm-2.5 18.8h5v-2.5h-5v2.5z" />
          </symbol>
          <symbol id="xljy" viewBox="0 0 30 30" title="学历校验">
            <path d="M22.5 22.2H25v5.3H5v-25h14.6L25 6.7V13h-2.5V7.9L18.8 5H7.5v20h15v-2.8zM10 8.8h10v2.5H10V8.8zM17 21l6-6 1.5 1.5L17 24l-4.5-4.5L14 18l3 3z" />
          </symbol>
          <symbol id="jfxx" viewBox="0 0 30 30" title="交费信息">
            <path d="M15 2.5c6.9 0 12.5 5.6 12.5 12.5S21.9 27.5 15 27.5 2.5 21.9 2.5 15 8.1 2.5 15 2.5zM15 25c5.5 0 10-4.5 10-10S20.5 5 15 5 5 9.5 5 15s4.5 10 10 10zm-1.2-10H10v-2.5h3.2l-2.8-2.8 1.8-1.8 2.9 2.9L18 7.9l1.8 1.8-2.8 2.8h3V15h-3.8v1.2H20v2.5h-3.8v3.8h-2.5v-3.8H10v-2.5h3.8V15z" />
          </symbol>
          <symbol id="zkzxz" viewBox="0 0 30 30" title="准考证下载">
            <path d="M23.8 15v8.8H6.2V15H3.8v8.8c0 1.4 1.1 2.5 2.5 2.5h17.5c1.4 0 2.5-1.1 2.5-2.5V15h-2.5zm-7.6.8l3.2-3.2 1.8 1.8-6.2 6.2-6.2-6.2 1.8-1.8 3.2 3.2v-12h2.5v12z" fill="#ccc" />
          </symbol>
          <symbol id="wbgg" viewBox="0 0 30 30" title="网报公告">
            <path d="M18.8 3.8v22.5h-1.2l-5-5h-10V8.8h10l5-5h1.2zm-2.6 4.7l-2.7 2.7H5v7.5h8.5l2.7 2.7V8.5zm10.3 5V16h-3.8v-2.5h3.8zm-3 9.3l-2.2-2.2 1.8-1.8 2.2 2.2-1.8 1.8zM25.2 8L23 10.2l-1.8-1.8 2.2-2.2L25.2 8z" />
          </symbol>
          <symbol id="xxtz" viewBox="0 0 30 30" title="消息通知">
            <path d="M12.5 26h5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.2-2.5-2.5zM15 1.6c1 0 1.9.8 1.9 1.9V5c3.9.8 6.9 4.3 6.9 8.5V21l2.5 2.5v1.2H3.8v-1.2L6.3 21v-7.5c0-4.2 2.9-7.7 6.9-8.5V3.4c-.1-1 .8-1.8 1.8-1.8zm0 5.6c-3.4 0-6.2 2.8-6.2 6.2v8.8h12.5v-8.8c-.1-3.4-2.8-6.2-6.3-6.2z" />
          </symbol>
          <symbol id="wsdc" viewBox="0 0 30 30" title="网上调查">
            <path d="M23.8 3.8c1.4 0 2.5 1.1 2.5 2.5v17.5c0 1.4-1.1 2.5-2.5 2.5H5.7c-.5-.1-.9-.4-1.3-.7-.2-.2-.4-.5-.5-.8-.1-.3-.2-.6-.2-1V6.2c0-.3.1-.7.2-1 .2-.2.4-.5.6-.7.3-.3.8-.6 1.3-.7.2 0 .3-.1.5-.1h5.2c.5-1.4 1.9-2.5 3.5-2.5s3 1 3.5 2.5h5.3zM15 3.4c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9zm8.8 20.4V6.2H6.2v17.5h17.6zm-15-5h8.8v2.5H8.8v-2.5zm0-5h12.5v2.5H8.8v-2.5zm0-5h12.5v2.5H8.8V8.8z" />
          </symbol>
          <symbol id="cjwt" viewBox="0 0 30 30" title="常见问题">
            <path d="M13.8 22.5h2.5V20h-2.5v2.5zm1.2-20C8.1 2.5 2.5 8.1 2.5 15S8.1 27.5 15 27.5 27.5 21.9 27.5 15 21.9 2.5 15 2.5zM15 25C9.5 25 5 20.5 5 15S9.5 5 15 5s10 4.5 10 10-4.5 10-10 10zm0-17.5c-2.8 0-5 2.2-5 5h2.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5c0 2.5-3.8 2.2-3.8 6.2h2.5c0-2.8 3.8-3.1 3.8-6.2 0-2.8-2.2-5-5-5z" />
          </symbol>
          <symbol id="xxda" viewBox="0 0 30 30" title="学信档案">
            <path d="M16.3 6.3c-.2 1.5-.5 3-.9 4.4l-4.6-2.6c0 1.5-.2 2.9-.5 4.3L5.7 9.7c.3.9.4 1.8.4 2.8 0 .9-.1 1.7-.3 2.5-.9 3.6-3 6.8-5.8 9.2h26c2.4-2.7 4-6.2 4-10.1L16.3 6.3zm-8.2 9.4c.1-.5.3-1 .3-1.6l1.2.7c-.9 2.6-2.3 5-4.1 7.1h-.2c1.3-1.9 2.2-4 2.8-6.2zm.5 6.2c2.1-2.9 3.6-6.3 4.2-9.8l1.7 1c-1.3 3.3-3.3 6.3-5.8 8.8h-.1zm16.3 0H12c2.9-3.4 5-7.5 6-11.8l9.5 5.5c-.2 2.2-1.1 4.4-2.6 6.3z"/>
          </symbol>
          <symbol id="zycp" viewBox="0 0 30 30" title="职业测评">
            <path d="M23.8 3.8c1.4 0 2.5 1.1 2.5 2.5v17.5c0 1.4-1.1 2.5-2.5 2.5H5.7c-.5-.1-.9-.4-1.3-.7-.2-.2-.4-.5-.5-.8s-.2-.6-.2-1V6.2c0-.3.1-.7.2-1 .2-.2.4-.5.6-.7.3-.3.8-.6 1.3-.7.2 0 .3-.1.5-.1h5.2c.5-1.4 1.9-2.5 3.5-2.5s3 1 3.5 2.5h5.3v.1zM15 3.4c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9zm8.8 20.4V6.2H6.2v17.5l17.6.1zm-10.2-3.4l-4.8-4.8 1.8-1.8 4.8 4.8-1.8 1.8zm7.6-7.6l-7.6 7.6-1.8-1.8 7.6-7.6 1.8 1.8z"/>
          </symbol>
        </defs>
      </svg>
      <div class="header">
        <div class="main clearfix">
          <div class="logo">
            <h1>2020年全国硕士研究生招生考试
              <div class="sys-name">
                <div class="sys-name-content">网上报名平台</div>
              </div>
            </h1>
          </div>
          <div class="user">
            <a class="home mark" href="/">
              <i class="ivu-icon ivu-icon-ios-home f-22"></i>&nbsp;首页
            </a>
            <a class="user-name" title="13611070198">用户</a>
            <a class="exit" >退出</a>
          </div>
        </div>
      </div>
      <div id="app" v-cloak>
        <div class="main nopadding-card margin-top-30 shadow-box">
          <a class="wsdc-banner" id="survey-do" target="_blank">
            <div class="main-title">报名前请先进行网上调查</div>
            <div class="sub-title">大约3-5分钟
              <i class="el-icon-arrow-right forward-little"></i>
            </div>
          </a>
        </div>
        <div class="main margin-top-30 margin-bottom-30 clearfix">
          <div class="nopadding-card shadow-box" style="position: relative; width:575px; float: left;">
            <a>
              <div class="yzwb-box2 clearfix">
                <span class="img-dtxun"></span>
                <i class="el-icon-arrow-right forward"></i>
                <div class="yzwb-box2-num" style="background: #ccc;">
                  1
                </div>
                <div class="yzwb-box2-cnt">填写考生信息<span class="c-red" style="font-size: 13px;">（可前往研招网试用，已填信息支持修改）</span><br>
                  <span class="yzwb-box2-tip">9月12日开始</span>
                </div>
              </div>
            </a>
          </div>
          <div class="nopadding-card shadow-box" style="width:575px; float: right;">
            <router-link to="/Process">
              <div class="yzwb-box2 clearfix">
                <span class="img-dtx"></span>
                <i class="el-icon-arrow-right forward" style="color: #1787e0;"></i>
                <div class="yzwb-box2-num">
                  2
                </div>
                <div class="yzwb-box2-cnt">填写报考信息<br>
                  <span class="yzwb-box2-tip">预报名：9月24日-27日，报名：10月10日-31日</span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="main clearfix">
          <div class="main-nav clearfix">
            <div class="item-bmxz">
              <router-link to="/baomingxuzhi">
                <div class="van-tabbar-item__icon">
                  <svg class="main-nav-iconfirst">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#bmxz"></use>
                  </svg>
                  <div class="van-icon__info">必读</div>
                </div>
                <div class="van-tabbar-item__text">报名须知</div>
              </router-link>
            </div>
            <div class="item-bmxz">
              <a target="_blank">
                <div class="van-tabbar-item__icon">
                  <svg class="main-nav-icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#wbgg"></use>
                  </svg>
                </div>
                <div class="van-tabbar-item__text">网报公告</div>
              </a>
            </div>
            <div class="item-bmxz">
              <a class="cursor-default c-grey">

                <div class="van-tabbar-item__icon">
                  <svg class="main-nav-icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#zkzxz"></use>
                  </svg>
                </div>
                <div class="van-tabbar-item__text">准考证下载</div>
              </a>
            </div>
            <div class="item-bmxz">
              <a>
                <div class="van-tabbar-item__icon">
                  <svg class="main-nav-icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#xxtz"></use>
                  </svg>
                </div>
                <div class="van-tabbar-item__text">消息通知</div>
              </a>
            </div>
            <div class="item-bmxz">
              <a target="_blank">
                <div class="van-tabbar-item__icon">
                  <svg class="main-nav-icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#wsdc"></use>
                  </svg>
                </div>
                <div class="van-tabbar-item__text">网上调查</div>
              </a>
            </div>
            <div class="item-bmxz">
              <a target="_blank">
                <div class="van-tabbar-item__icon">
                  <svg class="main-nav-icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#cjwt"></use>
                  </svg>
                </div>
                <div class="van-tabbar-item__text">常见问题</div>
              </a>
            </div>
            <div class="item-bmxz">
              <a target="_blank">
                <div class="van-tabbar-item__icon">
                  <svg class="main-nav-icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#xxda"></use>
                  </svg>
                </div>
                <div class="van-tabbar-item__text">学信档案</div>
              </a>
            </div>
            <div class="item-bmxz">
              <a target="_blank">
                <div class="van-tabbar-item__icon">
                  <svg class="main-nav-icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#zycp"></use>
                  </svg>
                </div>
                <div class="van-tabbar-item__text">职业测评</div>
              </a>
            </div>
          </div>
          <p class="c-red">该部分功能可前往研招网试用（模拟报名系统暂不支持）</p>
        </div>

        <div class="main padding-10 margin-bottom-30 line-height-2 clearfix">
          <div class="f-bold f-16">注意事项</div>
          <div class="c-grey">1、推荐使用最新版的
            <a href="https://www.google.cn/chrome/" target="_blank">Chrome</a>、
            <a href="http://firefox.com.cn/download/" target="_blank">Firefox</a>、
            <a href="https://www.microsoft.com/zh-cn/windows/microsoft-edge" target="_blank">Microsoft Edge</a> 等浏览器，其它浏览器可能不能正常使用本系统；<br> 2、下载pdf格式的文件，请
            <a href="http://www.foxitsoftware.cn/downloads/" target="_blank">下载免费pdf文件阅读器Foxit Reader</a> 或到其它合法网站自行下载pdf阅读器；<br> 3、报名过程中遇到问题请与客服人员联系确认，电话：010-82199588，邮件：kefu#chsi.com.cn（将#替换为@）。如遇线路繁忙导致电话长时间未接通，建议使用电子邮件，并在邮件中尽量详细地描述咨询问题、填报信息以及系统的反馈信息。
          </div>
        </div>
        <div class="main ewm-box c-grey clearfix" >
          <div class="img-con">
            <img src="//t4.chei.com.cn/yz/apply/assets/images/dyh.png" width="121" border="0">
          </div>
          <div class="text-con">
            <h6>研招网资讯</h6>
            <p>权威发布研招资讯和提示信息</p>
          </div>
          <div class="img-con">
            <img src="//t2.chei.com.cn/yz/apply/assets/images/fwh.png" width="121" border="0">
          </div>
          <div class="text-con">
            <h6>研招网</h6>
            <p>研招关键节点提醒及相关信息查询</p>
          </div>
        </div>
      </div>
      <div class="footer c-tip">
        <div class="main clearfix">

        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'wangshangdiaocha'
}
</script>

<style scoped>
  @import "../../../static/wb-pc.css";
  a{ text-decoration:none}
</style>



// WEBPACK FOOTER //
// src/components/wangshangdiaocha/wangshangdiaocha.vue